// extracted by mini-css-extract-plugin
export default {"drawer":"kS","drawerheader":"lS","retake_quiz_bottom_bar":"mS","extra_drawer":"nS","not_answered_questions":"oS","question_ui":"pS","accordion_details":"qS","retake_quiz":"rS","accordions":"sS","accordion_root":"tS","accordion_summary_text":"uS","animation":"vS","show_animation":"wS","overflow_hidden":"xS"};
    if(module.hot) {
      // 1713361653416
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  